import { ConsumptionHistoryChartType } from "@/types/billing"

import { apiFetch, formatDate } from "../utils"

const billingUrl = `himo-billing/`

export async function getConsumptionHistory(
  consumerId: number,
  year: number,
): Promise<ConsumptionHistoryChartType[]> {
  const response = await apiFetch(
    `${billingUrl}consumption-history/${consumerId}?year=${year}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  )
  if (!response.ok) {
    throw new Error(
      `Error fetching consumption history: ${response.statusText}`,
    )
  }

  const data = await response.json()
  console.log("consumption history chart: ", data)
  return data
}

export async function getConsumerDemographicPieChartAnalytics(years: number) {
  const response = await apiFetch(
    `${billingUrl}analytics/consumer-demographic/pie/?year=${years}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  )
  if (!response.ok) {
    throw new Error(
      `Error fetching consumption history: ${response.statusText}`,
    )
  }

  const data = await response.json()

  return data
}

export async function getConsumerDemographicBarChartAnalytics(years: number) {
  const response = await apiFetch(
    `${billingUrl}analytics/consumer-demographic/bar/?year=${years}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  )
  if (!response.ok) {
    throw new Error(
      `Error fetching consumption history: ${response.statusText}`,
    )
  }

  const data = await response.json()

  return data
}

//this used to get analytics card consumer type overview
export async function getConsumersTypesOverview(days: number) {
  const response = await apiFetch(
    `${billingUrl}consumers-types-overview?days=${days}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  )
  if (!response.ok) {
    throw new Error(
      `Error fetching Consumers Types Overview: ${response.statusText}`,
    )
  }

  const data = await response.json()

  return data
}

export async function getRevenuePieAnalytics(year: number) {
  const response = await apiFetch(
    `${billingUrl}analytics/revenue/pie/?year=${year}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  )
  if (!response.ok) {
    throw new Error(
      `Error fetching Revenue Analytics Pie: ${response.statusText}`,
    )
  }

  const data = await response.json()

  return data
}

export async function getRevenueBarAnalytics(year: number) {
  const response = await apiFetch(
    `${billingUrl}analytics/revenue/bar/?year=${year}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  )
  if (!response.ok) {
    throw new Error(
      `Error fetching Revenue Analytics Bar: ${response.statusText}`,
    )
  }

  const data = await response.json()

  return data
}

export async function getConsumptionTrendAreaAnalytics(years: string[]) {
  const queryYears = years.join(",")
  console.log(queryYears)

  const response = await apiFetch(
    `${billingUrl}analytics/consumption-trend/area/?years=${queryYears}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  )
  if (!response.ok) {
    throw new Error(
      `Error fetching Consumption Trends Area Chart: ${response.statusText}`,
    )
  }

  const data = await response.json()

  return data
}
export async function getConsumptionTrendPieAnalytics(
  fromDate: string | Date,
  toDate: string | Date,
) {
  const formattedFromDate = formatDate(fromDate)
  const formattedToDate = formatDate(toDate)

  const response = await apiFetch(
    `${billingUrl}analytics/consumption-trend/pie/?from_date=${formattedFromDate}&to_date=${formattedToDate}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  )
  if (!response.ok) {
    throw new Error(
      `Error fetching Consumption Trends PieChart: ${response.statusText}`,
    )
  }

  const data = await response.json()

  return data.total_consumption_distribution
}
